export default __webpack_public_path__ + "static/media/ico-light.963020b5.svg";